var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.strength.value
    ? _c("Chart", {
        ref: "chartReference",
        attrs: { options: _vm.chartOptions }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }